var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    [
      _vm.permiteConsultaSolicitudes
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/consultaSolicitudes" },
            },
            [
              _c("b-icon", { attrs: { icon: "journal-text" } }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("apeironGwApp.consultaSolicitudes.title")
                  ),
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isStaff && _vm.authenticated
        ? _c(
            "b-link",
            { staticClass: "btn-home m-3", attrs: { to: "/solicitud" } },
            [
              _c("span", { staticClass: "icon-solicitud" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(_vm.$t("global.menu.entities.solicitud")),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      (_vm.isStaff && _vm.authenticated) ||
      _vm.hasAnyAuthority(["ROLE_AUDITOR"])
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/solicitud/administracion" },
            },
            [
              _c("span", { staticClass: "icon-admin-solicitud" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("global.menu.entities.adminSolicitud")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isStaff && _vm.authenticated
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/documentos/Acreditaciones" },
            },
            [
              _c("span", { staticClass: "icon-pdf" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("global.menu.entities.documentosAcreditaciones")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isStaff && _vm.authenticated
        ? _c(
            "b-link",
            { staticClass: "btn-home m-3", attrs: { to: "/revision" } },
            [
              _c("span", { staticClass: "icon-revision" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(_vm.$t("global.menu.entities.revision")),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority(["ROLE_USER", "ROLE_SOPORTE"]) && _vm.authenticated
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/bandejaSolicitudes" },
            },
            [
              _c("span", { staticClass: "icon-solicitud" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(_vm.$t("evaluacionIndividual")),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority("ROLE_INNOVADOR") && _vm.authenticated
        ? _c(
            "b-link",
            { staticClass: "btn-home m-3", attrs: { to: "/solucion" } },
            [
              _c("span", { staticClass: "icon-soluciones" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(_vm.$t("global.menu.entities.solucion")),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority("ROLE_MODELADOR") && _vm.authenticated
        ? _c(
            "b-link",
            { staticClass: "btn-home m-3", attrs: { to: "/form" } },
            [
              _c("span", { staticClass: "icon-evaluacion-2" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(_vm.$t("global.menu.entities.form")),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority("ROLE_OPERADOR") && _vm.authenticated
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/evaluacion/adminComisionesList" },
            },
            [
              _c("span", { staticClass: "icon-evaluacion" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("global.menu.entities.adminComisionesList")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority("ROLE_OPERADOR") && _vm.authenticated
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/asignacion/asignacionSolicitudes" },
            },
            [
              _c("span", { staticClass: "icon-solicitud" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("global.menu.entities.asignacionSolicitudes")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority(["ROLE_USER", "ROLE_SOPORTE"]) && _vm.authenticated
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/bandejaPlenariaSolicitud" },
            },
            [
              _c("span", { staticClass: "icon-solicitud" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("global.menu.entities.bandejaPlenariaSolicitud")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority("ROLE_OPERADOR") && _vm.authenticated
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/bandeja/administracion" },
            },
            [
              _c("span", { staticClass: "icon-solicitud" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("global.menu.entities.bandejaAdminRevisiones")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority(["ROLE_USER", "ROLE_SOPORTE"]) && _vm.authenticated
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/evaluacion/dictamenPlenaria" },
            },
            [
              _c("span", { staticClass: "icon-pdf" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("global.menu.entities.dictamenPlenaria")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority(["ROLE_OPERADOR"]) && _vm.authenticated
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/evaluacion/adminDictamen" },
            },
            [
              _c("span", { staticClass: "icon-pdf" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("global.menu.entities.adminDictamen")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority("ROLE_OPERADOR") && _vm.authenticated
        ? _c(
            "b-link",
            { staticClass: "btn-home m-3", attrs: { to: "/consejoGeneral" } },
            [
              _c("span", { staticClass: "icon-evaluacion" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("global.menu.entities.consejoGeneral")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority("ROLE_OPERADOR") && _vm.authenticated
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/evaluacion/insaculacion" },
            },
            [
              _c("span", { staticClass: "icon-comunidades" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("global.menu.entities.insaculacion")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority("ROLE_OPERADOR") && _vm.authenticated
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/regitroMovimientoOperador" },
            },
            [
              _c("span", { staticClass: "icon-evaluacion" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(_vm.$t("apeironGwApp.movimiento.titulo")),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority(["ROLE_OPERADOR", "ROLE_AUDITOR"]) &&
      _vm.authenticated
        ? _c(
            "b-link",
            { staticClass: "btn-home m-3", attrs: { to: "/reportes" } },
            [
              _c("span", { staticClass: "icon-evaluacion" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(_vm.$t("global.menu.entities.reportes")),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority([
        "ROLE_OPERADOR_PROGRAMA",
        "ROLE_AUDITOR",
        "ROLE_USER",
      ]) && _vm.authenticated
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/seguimientoBecasNacionales" },
            },
            [
              _c("span", {
                staticClass: "icon-mexico",
                staticStyle: { "font-weight": "bold" },
              }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("global.menu.entities.seguimientoBecasNacionales")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority(["ROLE_OPERADOR", "ROLE_AUDITOR", "ROLE_USER"]) &&
      _vm.authenticated
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/becasAlExtranjero" },
            },
            [
              _c("b-icon", { attrs: { icon: "globe2" } }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("global.menu.entities.becasExtranjero")
                  ),
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority([
        "ROLE_OPERADOR_PROGRAMA",
        "ROLE_AUDITOR",
        "ROLE_USER",
      ]) && _vm.authenticated
        ? _c(
            "b-link",
            { staticClass: "btn-home m-3", attrs: { to: "/exbecarios" } },
            [
              _c("span", {
                staticClass: "fa fa-graduation-cap",
                staticStyle: { "font-size": "1.5rem", color: "#611232" },
              }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("global.menu.entities.exbecarios")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority(["ROLE_AUDITOR", "ROLE_USER"]) && _vm.authenticated
        ? _c(
            "b-link",
            { staticClass: "btn-home m-3", attrs: { to: "/snp" } },
            [
              _c("b-icon", { attrs: { icon: "file-ppt" } }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(_vm.$t("global.menu.entities.snp")),
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority(["ROLE_AUDITOR", "ROLE_USER"]) && _vm.authenticated
        ? _c(
            "b-link",
            { staticClass: "btn-home m-3", attrs: { to: "/gpln" } },
            [
              _c("b-icon", { attrs: { icon: "journal-text" } }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(_vm.$t("global.menu.entities.gpln")),
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority("ROLE_OPERADOR") && _vm.authenticated
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/cancelar/solicitudes" },
            },
            [
              _c("span", { staticClass: "icon-admin-solicitud" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("global.menu.entities.cancelarSolicitudes")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority("ROLE_FIRMAR_DOCUMENTOS_SNII") && _vm.authenticated
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/bandejaFormalizacion" },
            },
            [
              _c("span", { staticClass: "icon-evaluacion" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("global.menu.entities.bandejaFormalizacion")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority(["ROLE_FIRMAR_DOCUMENTOS_SNII"]) && _vm.authenticated
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/asignar-firmante-formalizacion" },
            },
            [
              _c("span", { staticClass: "icon-evaluacion" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("global.menu.entities.bandejaAsignarFirmante")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority(["ROLE_USER", "ROLE_OPERADOR"]) && _vm.authenticated
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/becas-extranjeras/evaluacion" },
            },
            [
              _c("span", { staticClass: "icon-revision" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("global.menu.entities.bandejaEvaluador")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority(["ROLE_OPERADOR", "ROLE_SNI"])
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/administracion/vigencias" },
            },
            [
              _c("span", { staticClass: "icon-solicitud" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(_vm.$t("global.menu.entities.vigencias")),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority(["ROLE_FIRMAR_DOCUMENTOS", "ROLE_BECAS"]) &&
      _vm.authenticated
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/bandejaFormalizacionGeneralBecas" },
            },
            [
              _c("span", { staticClass: "icon-evaluacion" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("global.menu.entities.bandejaFormalizacionGeneral")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority(["ROLE_OPERADOR"]) &&
      _vm.authenticated &&
      !_vm.hasAnyAuthority(["ROLE_FIRMAR_DOCUMENTOS"])
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/bandejaFormalizacionBecas" },
            },
            [
              _c("span", { staticClass: "icon-evaluacion" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("global.menu.entities.bandejaFormalizacionGeneral")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority("ROLE_INNOVADOR") && _vm.authenticated
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/regenerarDocumentosFormalizacion" },
            },
            [
              _c("span", { staticClass: "icon-evaluacion" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("global.menu.entities.regeneraDocsFormalizacion")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority("ROLE_INNOVADOR") && _vm.authenticated
        ? _c(
            "b-link",
            {
              staticClass: "btn-home m-3",
              attrs: { to: "/regenerarDocumentosBecasNacionales" },
            },
            [
              _c("span", { staticClass: "icon-evaluacion" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("global.menu.entities.regeneraDocsBecasNacionales")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority("ROLE_FIRMAR_DOCUMENTOS_SNII") &&
      _vm.authenticated &&
      false
        ? _c(
            "b-link",
            { staticClass: "btn-home m-3", attrs: { to: "/adminMasterSnii" } },
            [
              _c("b-icon", { attrs: { icon: "shield-shaded" } }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("global.menu.entities.bandejaAdminMaestro")
                  ),
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "seguimientoCoordinador",
          attrs: {
            size: "lg",
            "header-bg-variant": "primary",
            title: _vm.$t("seguimientoCoordinador.titulo"),
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "b-row",
                    { staticClass: "w-100", attrs: { "align-h": "center" } },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "outline-success" },
                              on: {
                                click: function ($event) {
                                  return _vm.hideModalseguimientoCoordinador()
                                },
                              },
                            },
                            [
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("entity.action.accept")) +
                                    "\n            "
                                ),
                              ],
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          [
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c("div", {
                    staticClass: "text-justify",
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("seguimientoCoordinador.aviso")),
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-2" },
                    [
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("seguimientoCoordinador.mesesPendientes")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(
                        _vm.periodosVerificacion,
                        function (verificacion, index) {
                          return _c(
                            "b-badge",
                            {
                              key: index,
                              staticClass: "mr-2",
                              attrs: { variant: "warning" },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(verificacion.descripcion) +
                                  "\n            "
                              ),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                ]),
              ],
              1
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }